import React from 'react';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Box, TabsProps } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';

export const FsTabsContainer = withStyles(({ spacing }: Theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: spacing(2),
  },
}))((props) => <Box {...props} />);

export interface FsTabsProps extends Pick<TabsProps, 'variant'> {
  value: number;
  onChange: (
    event: React.ChangeEvent<Record<string, unknown>>,
    newValue: number
  ) => void;
}

export const FsTabs = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      backgroundColor: palette.grey[100],
      borderRadius: spacing(1),
    },
    indicator: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      height: '100%',
      '& > span': {
        width: '100%',
        height: 'calc(100% - 1px)',
        backgroundColor: palette.primary.light,
        borderRadius: spacing(1),
        boxShadow: `0px 1px 0 0 ${palette.primary.main}, inset 0px -1px 0px ${palette.primary.main}`,
      },
    },
  })
)((props: FsTabsProps) => (
  <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />
));
